import React from 'react';
import Progress from '@visa/vds/progress';

const MCSOverlayLoading = (props) => {

    let loadingOverlayStyle= {
        backgroundColor: props.bgColor ?? "black",
        opacity: props.opacity ?? "0.8",
        height: "100%",
        width: "100%",
        zIndex: '9999',
        position: "fixed",
        top: 0,
        left:0,
    }

    let loadingCircleStyle={
        top: "50%",
        textAlign:"center",
        width:"100%"
    }

    return(
        <div style={loadingOverlayStyle}>
            <Progress style={loadingCircleStyle} type="spinner" />
        </div>

    )
      

}

export default MCSOverlayLoading;